import * as Animate from "react-reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const pillars = [
  {
    number: "01",
    title: "Utiva Learn",
    desc: "Build practical skills that move with the world of work.",
    points: [
      "Live, mentor-led learning",
      "Projects and portfolio evidence",
      "Career and workplace preparation",
    ],
    cta: "Explore programs",
    to: "/school",
  },
  {
    number: "02",
    title: "Utiva Hire",
    desc: "Meet assessed professionals from an active global talent community.",
    points: [
      "Role-specific talent matching",
      "Assessment and readiness evidence",
      "Flexible ways to build your team",
    ],
    cta: "Hire talent",
    to: "/hire",
  },
  {
    number: "03",
    title: "Manage & Pay",
    desc: "Support global team members beyond the moment they are hired.",
    points: [
      "International talent deployment",
      "Multi-country team support",
      "Payroll and operational infrastructure",
    ],
    cta: "Talk to Utiva",
    to: "/pay",
  },
];

const AboutPlatformSection = () => {
  return (
    <section className="bg-hire-tint-blue py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            One connected platform
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-xl tracking-[-0.03em] text-primary">
              We support the full talent journey.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              Learning is stronger when it leads somewhere. Hiring works better
              when capability is visible. Global teams grow with the right
              infrastructure behind them.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {pillars.map((pillar) => (
            <Animate.Fade bottom key={pillar.number}>
              <article className="h-full flex flex-col rounded-2xl p-7 bg-white shadow-course-card">
                <div className="flex items-center justify-between mb-6">
                  <span className="text-secondary font-poppins text-xs font-extrabold">
                    {pillar.number}
                  </span>
                  <span className="w-9 h-9 rounded-full border border-hire-line grid place-items-center">
                    <ArrowUpRight className="w-3.5 h-3.5 text-primary" />
                  </span>
                </div>
                <h3 className="font-poppins font-extrabold text-2xl text-primary mb-4">
                  {pillar.title}
                </h3>
                <p className="text-gray font-poppins text-sm leading-relaxed mb-5 lg:mb-10">
                  {pillar.desc}
                </p>
                <ul className="grid gap-0 mb-6">
                  {pillar.points.map((point) => (
                    <li
                      key={point}
                      className="flex items-center gap-2.5 text-default font-poppins text-sm py-3 border-b border-hire-line"
                    >
                      <span className="text-secondary" aria-hidden="true">
                        ✓
                      </span>
                      {point}
                    </li>
                  ))}
                </ul>
                <Link
                  to={pillar.to}
                  className="mt-auto font-poppins font-bold text-primary text-sm underline decoration-secondary decoration-2 underline-offset-4 hover:opacity-80 transition-opacity"
                >
                  {pillar.cta} →
                </Link>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutPlatformSection;
